import { type IntlShape } from 'react-intl'
import useIntl from 'react-intl/src/components/useIntl'

import {
  type OfferV11,
  type PimManufacturerV1,
  type PimProductV11,
  type PimProductV1Rating,
  type PimProductWithVariantsV1,
  PrescriptionPrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

import { IMAGE_PRODUCT_FALLBACK_SRC } from '../../../image/IMAGE_PRODUCT_FALLBACK_SRC'
import { IMAGE_PRODUCT_PRESCRIPTION_FALLBACK_SRC } from '../../../image/IMAGE_PRODUCT_PRESCRIPTION_FALLBACK_SRC'
import { productAccessorIsPrescriptionProduct } from '../../../product-page/model/productAccessor/productAccessorIsPrescriptionProduct'
import { urlGetRelativeUrl } from '../../../url-handling/url'
import { useExperimentalAddStaticFileHost } from '../../new-cdn-experiment/useExperimentalAddStaticFileHost'

export const useExperimentOwnBrandsOverlayProductProperties = (
  ownBrandsProduct: PimProductWithVariantsV1,
): {
  currentPrescriptionType: PrescriptionPrescriptionTypeEnum
  fallbackImageUrl: string
  href: string
  images: string[] | undefined
  intl: IntlShape
  manufacturer: PimManufacturerV1 | undefined
  name: string
  offers: OfferV11[] | undefined
  path: string
  productAttributes: string
  rating: PimProductV1Rating | undefined
  upid: string
  variants: PimProductV11[]
} => {
  const { addStaticCdnHostToUrl } = useExperimentalAddStaticFileHost()
  const fallbackImageUrl = productAccessorIsPrescriptionProduct(
    ownBrandsProduct,
  )
    ? addStaticCdnHostToUrl(IMAGE_PRODUCT_PRESCRIPTION_FALLBACK_SRC)
    : addStaticCdnHostToUrl(IMAGE_PRODUCT_FALLBACK_SRC)

  const intl = useIntl()
  const {
    images,
    manufacturer,
    name,
    offers,
    package_size: packageSize,
    path,
    pharma_form: pharmaForm,
    rating,
    upid,
    variants,
  } = ownBrandsProduct
  const attributes = [
    [packageSize?.quantity, packageSize?.unit].filter(Boolean).join(' '),
    pharmaForm?.label ?? '',
  ]

  const productAttributes = attributes.filter(Boolean).join(' | ')
  const currentPrescriptionType =
    PrescriptionPrescriptionTypeEnum.NoPrescription

  return {
    currentPrescriptionType,
    fallbackImageUrl,
    href: urlGetRelativeUrl(path),
    images,
    intl,
    manufacturer,
    name,
    offers,
    path,
    productAttributes,
    rating,
    upid,
    variants,
  }
}
